// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/es6.reflect.has.js
// module id = 410
// module chunks = 99